(function () {
  if (window.__trichoraPerfectV2Loaded) return;
  window.__trichoraPerfectV2Loaded = true;

  var TIER_CONFIG = {
    sub: [
      { idx: 0, code: 'IIUZ', variantId: 0, giftVariantIds: [], shortTitle: '1x Starter Kit', fullTitle: '1x Sonic Toothbrush (Starter Kit)', price: '', compare: '', save: '', brushes: 1, giftsText: '2 Free Heads & Bamboo Travel Case', giftsProp: '2x Bamboo Brush Heads + Bamboo Travel Case' },
      { idx: 1, code: '5QQf', variantId: 0, giftVariantIds: [], shortTitle: "2x Couple's Kit", fullTitle: "2x Sonic Toothbrushes (Couple's Kit)", price: '', compare: '', save: '', brushes: 2, giftsText: '4 Free Heads & 2 Travel Cases', giftsProp: '4x Bamboo Brush Heads + 2x Bamboo Travel Cases' },
      { idx: 2, code: 'zy08', variantId: 0, giftVariantIds: [], shortTitle: '3x Family Pack', fullTitle: '3x Sonic Toothbrushes (Family Pack)', price: '', compare: '', save: '', brushes: 3, giftsText: '6 Free Heads & 3 Travel Cases', giftsProp: '6x Bamboo Brush Heads + 3x Bamboo Travel Cases' }
    ],
    onetime: [
      { idx: 0, code: 'IIUZ', variantId: 0, giftVariantIds: [], shortTitle: '1x Starter Kit', fullTitle: '1x Sonic Toothbrush (Starter Kit)', price: '', compare: '', save: '', brushes: 1, giftsText: '2 Free Heads & Bamboo Travel Case', giftsProp: '2x Bamboo Brush Heads + Bamboo Travel Case' },
      { idx: 1, code: '5QQf', variantId: 0, giftVariantIds: [], shortTitle: "2x Couple's Kit", fullTitle: "2x Sonic Toothbrushes (Couple's Kit)", price: '', compare: '', save: '', brushes: 2, giftsText: '4 Free Heads & 2 Travel Cases', giftsProp: '4x Bamboo Brush Heads + 2x Bamboo Travel Cases' },
      { idx: 2, code: 'zy08', variantId: 0, giftVariantIds: [], shortTitle: '3x Family Pack', fullTitle: '3x Sonic Toothbrushes (Family Pack)', price: '', compare: '', save: '', brushes: 3, giftsText: '6 Free Heads & 3 Travel Cases', giftsProp: '6x Bamboo Brush Heads + 3x Bamboo Travel Cases' }
    ]
  };

  // t84: CJ product. Bristle = variant (one cart line per brush); free gifts ride on brush lines as a "Free gift" property (t85).
  var TRI_CFG = { horse: 0, boar: 0, tiers: [] };
  function applyCfg() {
    try {
      var cfgEl = document.getElementById('tri-bundle-cfg');
      if (cfgEl) TRI_CFG = JSON.parse(cfgEl.textContent);
    } catch (err) {}
    ['sub', 'onetime'].forEach(function (m) {
      TIER_CONFIG[m].forEach(function (t, i) {
        t.variantId = TRI_CFG.horse || 0;
        var tc = TRI_CFG.tiers && TRI_CFG.tiers[i];
        if (tc && tc.text) t.giftsProp = tc.text;
      });
    });
    if (window.TriBundle) window.TriBundle.cfg = TRI_CFG;
  }
  function bristleVariant(val) {
    return (val && val.indexOf('Boar') !== -1) ? (TRI_CFG.boar || TRI_CFG.horse) : TRI_CFG.horse;
  }
  window.TriBundle = { cfg: TRI_CFG, bristleVariant: bristleVariant };

  function shortBristleName(val) {
    if (!val) return 'Horse Soft';
    return val.indexOf('Boar') !== -1 ? 'Boar Firm' : 'Horse Soft';
  }

  function initBuyBoxAndSticky() {
    var kbBlock = document.querySelector('kaching-bundles-block');
    if (!kbBlock || kbBlock.dataset.triV2Init === '1') return;
    kbBlock.dataset.triV2Init = '1';
    applyCfg();
    kbBlock.dataset.cloneInit = '1'; // prevent duplicate init from tri-reviews.liquid

    var subButtons = Array.prototype.slice.call(kbBlock.querySelectorAll('.kaching-bundles__subscriptions .kaching-bundles__bar'));
    var bars = Array.prototype.slice.call(kbBlock.querySelectorAll('.kaching-bundles__bars > .kaching-bundles__bar[data-deal-bar-id]'));
    var savingsValEl = kbBlock.querySelector('.kaching-bundles-savings-summary__value');
    var saveLeadEl = kbBlock.querySelector('[data-tri-save-lead]');
    var noSaveLeadEl = kbBlock.querySelector('[data-tri-nosave-lead]');

    // t81: per-variant localized prices rendered by Liquid (Markets-aware) on each tier bar
    bars.forEach(function (bar, idx) {
      if (bar.dataset.triPrice === undefined) return;
      ['sub', 'onetime'].forEach(function (m) {
        var t = TIER_CONFIG[m][idx];
        if (!t) return;
        t.price = bar.dataset.triPrice || '';
        t.compare = bar.dataset.triCompare || '';
        t.save = bar.dataset.triSave || '';
      });
    });
    var giftSummaryEl = kbBlock.querySelector('[data-tri-gift-summary-text]');

    var form = document.getElementById('product-form-tri-s-main') || document.querySelector('form[action*="/cart/add"]');
    var propTier = document.getElementById('tri-prop-bundle-tier');
    var propB1 = document.getElementById('tri-prop-brush-1');
    var propB2 = document.getElementById('tri-prop-brush-2');
    var propB3 = document.getElementById('tri-prop-brush-3');
    var propGifts = document.getElementById('tri-prop-free-gifts');
    var sellingPlanInput = form ? form.querySelector('input[name="selling_plan"]') : null;
    var defaultSellingPlan = sellingPlanInput ? sellingPlanInput.value : '695424352556';
    var mainAtcBtn = document.getElementById('ProductSubmitButton-tri-s-main');
    var mainAtcText = mainAtcBtn ? mainAtcBtn.querySelector('[data-tri-main-atc-text]') : null;

    var stickyBar = document.getElementById('trichora-sticky-atc');
    var stickyTierBtns = stickyBar ? Array.prototype.slice.call(stickyBar.querySelectorAll('[data-sticky-tier-select]')) : [];
    var stickyTierLabel = stickyBar ? stickyBar.querySelector('[data-tri-sticky-tier-label]') : null;
    var stickyBristleSummary = stickyBar ? stickyBar.querySelector('[data-tri-sticky-bristle-summary]') : null;
    var stickyMobileTier = stickyBar ? stickyBar.querySelector('[data-tri-sticky-mobile-tier]') : null;
    var stickyMobileBristles = stickyBar ? stickyBar.querySelector('[data-tri-sticky-mobile-bristles]') : null;
    var stickyBtnText = stickyBar ? stickyBar.querySelector('[data-tri-sticky-btn-text]') : null;
    var stickySubmitBtn = stickyBar ? stickyBar.querySelector('[data-tri-sticky-submit]') : null;

    var currentMode = 'onetime';
    var selectedIdx = 1;

    // Track per-brush bristle choices for each tier
    var bristleState = {
      0: { 1: 'Soft Horsehair (Sensitive Gums)' },
      1: { 1: 'Soft Horsehair (Sensitive Gums)', 2: 'Firm Boar (Stain Polishing)' },
      2: { 1: 'Soft Horsehair (Sensitive Gums)', 2: 'Firm Boar (Stain Polishing)', 3: 'Soft Horsehair (Sensitive Gums)' }
    };

    function syncAllUI() {
      var modeTiers = TIER_CONFIG[currentMode];
      var activeTier = modeTiers[selectedIdx] || modeTiers[1];

      // 1. Update bundle cards
      bars.forEach(function (bar, idx) {
        var isSel = idx === selectedIdx;
        bar.classList.toggle('kaching-bundles__bar--selected', isSel);
        var radio = bar.querySelector('input[type="radio"]');
        if (radio) radio.checked = isSel;
        var priceEl = bar.querySelector('.kaching-bundles__bar-price');
        var fullPriceEl = bar.querySelector('.kaching-bundles__bar-full-price');
        if (priceEl && modeTiers[idx]) priceEl.textContent = modeTiers[idx].price;
        if (fullPriceEl && modeTiers[idx]) {
          fullPriceEl.textContent = modeTiers[idx].compare;
          fullPriceEl.style.display = modeTiers[idx].compare ? '' : 'none';
        }
      });

      // 2. Update savings & free gift summary
      if (savingsValEl) savingsValEl.textContent = activeTier.save;
      if (saveLeadEl) saveLeadEl.style.display = activeTier.save ? '' : 'none';
      if (noSaveLeadEl) noSaveLeadEl.style.display = activeTier.save ? 'none' : '';
      if (giftSummaryEl) giftSummaryEl.textContent = activeTier.giftsText;

      // 3. Update hidden line-item properties in product form
      var tierBristles = bristleState[selectedIdx] || bristleState[1];
      if (propTier) propTier.value = activeTier.fullTitle + ' (One-Time)';
      if (propGifts) propGifts.value = activeTier.giftsProp;
      if (sellingPlanInput) {
        if (currentMode === 'sub') {
          sellingPlanInput.disabled = false;
          sellingPlanInput.value = defaultSellingPlan;
        } else {
          sellingPlanInput.disabled = true;
          sellingPlanInput.value = '';
        }
      }

      if (propB1) {
        propB1.value = tierBristles[1] || 'Soft Horsehair (Sensitive Gums)';
      }
      if (propB2) {
        if (activeTier.brushes >= 2) {
          propB2.disabled = false;
          propB2.value = tierBristles[2] || 'Firm Boar (Stain Polishing)';
        } else {
          propB2.disabled = true;
          propB2.value = '';
        }
      }
      if (propB3) {
        if (activeTier.brushes >= 3) {
          propB3.disabled = false;
          propB3.value = tierBristles[3] || 'Soft Horsehair (Sensitive Gums)';
        } else {
          propB3.disabled = true;
          propB3.value = '';
        }
      }

      // 4. Build concise bristle summary text
      var bSummaryParts = [];
      for (var s = 1; s <= activeTier.brushes; s++) {
        bSummaryParts.push('#' + s + ': ' + shortBristleName(tierBristles[s]));
      }
      var bSummaryText = 'Brush ' + bSummaryParts.join(', ');

      // 4b. Sync active Shopify variant ID (brush #1 bristle) on form, Kaching block & sticky bar
      activeTier.variantId = bristleVariant(tierBristles[1]);
      if (form && activeTier.variantId) {
        var mainIdInput = form.querySelector('input[name="id"]');
        if (mainIdInput) mainIdInput.value = String(activeTier.variantId);
      }
      if (kbBlock && activeTier.variantId) {
        kbBlock.setAttribute('current-variant-id', String(activeTier.variantId));
      }
      if (stickyBar && activeTier.variantId) {
        stickyBar.setAttribute('data-variant-id', String(activeTier.variantId));
      }

      // 5. Update main ATC button text
      var atcLabel = 'ADD TO CART • ' + activeTier.price + (activeTier.save ? ' (SAVE ' + activeTier.save + ')' : '');
      if (mainAtcText) mainAtcText.textContent = atcLabel;

      // 6. Update Sticky Bottom ATC Bar
      stickyTierBtns.forEach(function (btn, idx) {
        btn.classList.toggle('is-active', idx === selectedIdx);
        var pSpan = btn.querySelector('[data-sticky-tier-price]');
        if (pSpan && modeTiers[idx]) pSpan.textContent = modeTiers[idx].price;
      });
      if (stickyTierLabel) stickyTierLabel.textContent = activeTier.shortTitle;
      if (stickyBristleSummary) stickyBristleSummary.textContent = bSummaryText;
      if (stickyMobileTier) stickyMobileTier.textContent = activeTier.shortTitle + ' • ' + activeTier.price;
      if (stickyMobileBristles) stickyMobileBristles.textContent = bSummaryParts.map(function (p) { return p.replace(/^#\d+:\s*/, ''); }).join(' + ');
      if (stickyBtnText) stickyBtnText.textContent = atcLabel;
    }

    // Bind subscription vs one-time toggle
    subButtons.forEach(function (btn, idx) {
      btn.addEventListener('click', function () {
        subButtons.forEach(function (b) { b.classList.remove('kaching-bundles__bar--selected'); });
        btn.classList.add('kaching-bundles__bar--selected');
        currentMode = idx === 0 ? 'sub' : 'onetime';
        syncAllUI();
      });
    });

    // Bind bundle tier bar selection
    bars.forEach(function (bar, idx) {
      bar.addEventListener('click', function (e) {
        if (e.target && e.target.closest('.tri-bristle-pill')) return;
        selectedIdx = idx;
        syncAllUI();
      });
    });

    // Bind per-brush bristle selector pills inside each tier
    kbBlock.querySelectorAll('.tri-bristle-selector-box').forEach(function (groupEl) {
      var groupIdx = parseInt(groupEl.getAttribute('data-tri-bristle-group'), 10) || 0;
      groupEl.querySelectorAll('.tri-bristle-pill').forEach(function (pill) {
        pill.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var slot = parseInt(pill.getAttribute('data-brush-slot'), 10) || 1;
          var val = pill.getAttribute('data-bristle-value');
          var rowPills = pill.parentElement.querySelectorAll('.tri-bristle-pill');
          rowPills.forEach(function (p) { p.classList.remove('is-active'); });
          pill.classList.add('is-active');
          var feelGuide = groupEl.querySelector('[data-tri-feel-guide]');
          if (feelGuide) {
            var isBoar = val && val.indexOf('Boar') !== -1;
            feelGuide.querySelectorAll('.tri-bristle-feel-item').forEach(function (fi) {
              var fType = fi.getAttribute('data-feel-type');
              fi.classList.toggle('is-active', isBoar ? fType === 'boar' : fType === 'horse');
            });
          }
          if (!bristleState[groupIdx]) bristleState[groupIdx] = {};
          bristleState[groupIdx][slot] = val;
          selectedIdx = groupIdx;
          syncAllUI();
        });
      });
    });

    // Bind Sticky Bar tier buttons & submit button
    stickyTierBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var tIdx = parseInt(btn.getAttribute('data-sticky-tier-select'), 10);
        if (!isNaN(tIdx)) {
          selectedIdx = tIdx;
          syncAllUI();
        }
      });
    });

    var isSubmittingBundle = false;
    function submitKachingBundle(e) {
      if (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
      if (isSubmittingBundle) return;
      isSubmittingBundle = true;

      var modeTiers = TIER_CONFIG[currentMode] || TIER_CONFIG.sub;
      var activeTier = modeTiers[selectedIdx] || modeTiers[1];
      var tierBristles = bristleState[selectedIdx] || bristleState[1];
      var bParts = [];
      for (var s = 1; s <= activeTier.brushes; s++) {
        bParts.push('Brush #' + s + ': ' + shortBristleName(tierBristles[s]));
      }

      // t85: one cart line per brush (CJ variant only); each brush line carries its share of the free kit as a "Free gift" property.
      // The cart drawer (TriCart.reconcile) re-derives these by brush order whenever the cart changes.
      var itemsPayload = [];
      var stamp = String(Date.now());
      var cfgTiers = (TRI_CFG && TRI_CFG.tiers) || [];
      for (var b = 1; b <= activeTier.brushes; b++) {
        var bp = { _tri_slot: stamp + '-' + b };
        var gl = cfgTiers[b - 1] && cfgTiers[b - 1].line;
        if (gl) bp['Free gift'] = gl;
        itemsPayload.push({ id: bristleVariant(tierBristles[b]), quantity: 1, properties: bp });
      }

      var origMainText = mainAtcText ? mainAtcText.textContent : '';
      var origStickyText = stickyBtnText ? stickyBtnText.textContent : '';
      if (mainAtcText) mainAtcText.textContent = 'ADDING BUNDLE + FREE GIFTS...';
      if (stickyBtnText) stickyBtnText.textContent = 'ADDING...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: itemsPayload })
      })
        .then(function (res) { return res.json(); })
        .then(function (r) {
          if (r && r.status && r.status >= 400) throw new Error(r.description || 'add failed');
          if (mainAtcText) mainAtcText.textContent = '✓ BUNDLE + FREE GIFTS ADDED!';
          if (stickyBtnText) stickyBtnText.textContent = '✓ ADDED!';
          document.dispatchEvent(new CustomEvent('kaching-cart:drawer-open', {
            detail: { cartOpenSource: 'add-to-cart', timestamp: Date.now() },
            bubbles: true,
            cancelable: true
          }));
          setTimeout(function () {
            isSubmittingBundle = false;
            syncAllUI();
          }, 1800);
        })
        .catch(function () {
          isSubmittingBundle = false;
          if (mainAtcText) mainAtcText.textContent = origMainText;
          if (stickyBtnText) stickyBtnText.textContent = origStickyText;
        });
    }

    if (form) {
      form.addEventListener('submit', submitKachingBundle, true);
    }

    if (stickySubmitBtn) {
      stickySubmitBtn.addEventListener('click', function (e) {
        submitKachingBundle(e);
      });
    }

    // Sticky Bar scroll visibility observer (shows after main ATC button scrolls above viewport, hides near footer)
    if (stickyBar && mainAtcBtn) {
      var footerEl = document.getElementById('shopify-section-sections--20599281778988__footer_section_3hjjaf') || document.querySelector('footer');
      var updateStickyVisibility = function () {
        var atcRect = mainAtcBtn.getBoundingClientRect();
        var pastAtc = atcRect.bottom < 0;
        var nearFooter = false;
        if (footerEl) {
          var fRect = footerEl.getBoundingClientRect();
          nearFooter = fRect.top < window.innerHeight + 40;
        }
        var show = pastAtc && !nearFooter;
        stickyBar.classList.toggle('is-visible', show);
        stickyBar.setAttribute('aria-hidden', show ? 'false' : 'true');
      };
      window.addEventListener('scroll', updateStickyVisibility, { passive: true });
      window.addEventListener('resize', updateStickyVisibility, { passive: true });
      updateStickyVisibility();
    }

    syncAllUI();
  }

  // Upgrade 1c & 6b: 1-Click In-Buy-Box Refill Add-On & Bottom Upsell 1-Click Add to Cart
  function initOneClickAddOns() {
    var addonPropInput = document.getElementById('tri-prop-refill-addon');

    document.querySelectorAll('[data-refill-addon-btn]').forEach(function (btn) {
      if (btn.dataset.bound === '1') return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', function () {
        var isAdded = btn.classList.toggle('is-added');
        var labelEl = btn.querySelector('.tri-refill-addon-btn__label');
        var addonName = btn.getAttribute('data-addon-name') || 'Extra 4-Pack';
        var variantId = btn.getAttribute('data-variant-id');

        if (isAdded) {
          if (labelEl) {
            btn.dataset.origHtml = labelEl.innerHTML;
            labelEl.innerHTML = '✓ Added ' + addonName;
          }
          // Update hidden property on main form
          if (addonPropInput) {
            addonPropInput.disabled = false;
            addonPropInput.value = addonName;
          }
          // Also fire async /cart/add.js so 1-click add works immediately
          if (variantId) {
            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({
                items: [{ id: Number(variantId), quantity: 1, properties: { 'Add-On Item': addonName } }]
              })
            }).catch(function () {});
          }
        } else {
          if (labelEl && btn.dataset.origHtml) {
            labelEl.innerHTML = btn.dataset.origHtml;
          }
          if (addonPropInput) {
            addonPropInput.disabled = true;
            addonPropInput.value = '';
          }
        }
      });
    });

    document.querySelectorAll('[data-upsell-atc]').forEach(function (btn) {
      if (btn.dataset.bound === '1') return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var labelSpan = btn.querySelector('[data-upsell-btn-label]') || btn;
        var itemTitle = btn.getAttribute('data-upsell-item') || 'Trichora Oral Care Essential';
        var itemPrice = btn.getAttribute('data-upsell-price') || '';
        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId) return;

        btn.classList.add('is-added');
        labelSpan.textContent = '✓ ADDED TO CART (' + itemPrice + ')';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            items: [{ id: Number(variantId), quantity: 1, properties: { 'Routine Add-On': itemTitle } }]
          })
        }).catch(function () {});

        setTimeout(function () {
          btn.classList.remove('is-added');
          labelSpan.textContent = '+ ADD TO CART — ' + itemPrice;
        }, 2800);
      });
    });
  }

  // Upgrade 3: Live In-Stock Dispatch Countdown & Dynamic Delivery Dates
  function initLiveDispatchEstimator() {
    var card = document.getElementById('tri-dispatch-estimator');
    if (!card || card.dataset.bound === '1') return;
    card.dataset.bound = '1';

    var countdownEl = card.querySelector('[data-tri-dispatch-countdown]');
    var datesEl = card.querySelector('[data-tri-delivery-dates]');

    function addBusinessDays(startDate, daysToAdd) {
      var d = new Date(startDate.getTime());
      var added = 0;
      while (added < daysToAdd) {
        d.setDate(d.getDate() + 1);
        var dow = d.getDay();
        if (dow !== 0 && dow !== 6) {
          added++;
        }
      }
      return d;
    }

    function fmtShortDate(d) {
      var days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
      var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      return days[d.getDay()] + ', ' + months[d.getMonth()] + ' ' + d.getDate();
    }

    function updateDispatch() {
      var now = new Date();
      var startDeliv = addBusinessDays(now, 3);
      var endDeliv = addBusinessDays(now, 5);
      if (datesEl) {
        datesEl.textContent = fmtShortDate(startDeliv) + ' – ' + fmtShortDate(endDeliv);
      }
      if (countdownEl) {
        // Calculate hours/mins until daily 5:00 PM dispatch cutoff (wrapping cleanly)
        var targetHour = 17;
        var hrsLeft = (targetHour - now.getHours() + 24) % 24;
        if (hrsLeft === 0 || hrsLeft > 8) hrsLeft = 3;
        var minsLeft = 59 - now.getMinutes();
        countdownEl.textContent = hrsLeft + ' hrs ' + (minsLeft < 10 ? '0' + minsLeft : minsLeft) + ' mins';
      }
    }

    updateDispatch();
    setInterval(updateDispatch, 60000);
  }

  // Upgrade 5: Interactive 4 Brushing Modes Switcher
  function initSonicModesExplorer() {
    var box = document.querySelector('[data-tri-modes-box]');
    if (!box || box.dataset.bound === '1') return;
    box.dataset.bound = '1';

    var pills = Array.prototype.slice.call(box.querySelectorAll('[data-mode-pill]'));
    var vpmEl = box.querySelector('[data-tri-mode-vpm]');
    var descEl = box.querySelector('[data-tri-mode-desc]');

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        pills.forEach(function (p) {
          p.classList.remove('is-active');
          p.setAttribute('aria-selected', 'false');
        });
        pill.classList.add('is-active');
        pill.setAttribute('aria-selected', 'true');
        if (vpmEl) vpmEl.textContent = pill.getAttribute('data-mode-vpm') || '';
        if (descEl) descEl.textContent = pill.getAttribute('data-mode-desc') || '';
      });
    });
  }

  function initSmoothAnchorDrawerClose() {
    document.querySelectorAll('.tri-mobile-nav-list a[href^="#"]').forEach(function (link) {
      if (link.dataset.boundAnchor === '1') return;
      link.dataset.boundAnchor = '1';
      link.addEventListener('click', function () {
        var drawerDetails = document.getElementById('Details-menu-drawer-container');
        if (drawerDetails && drawerDetails.hasAttribute('open')) {
          drawerDetails.removeAttribute('open');
          document.body.classList.remove('overflow-hidden-tablet', 'overflow-hidden-mobile');
        }
      });
    });
  }


  function initDtcJumpLinks() {
    document.querySelectorAll('[data-tri-jump], a[href^="#"]').forEach(function (link) {
      if (link.dataset.boundJump === '1') return;
      var href = link.getAttribute('href');
      if (!href || href.length < 2 || href.charAt(0) !== '#') return;
      link.dataset.boundJump = '1';
      link.addEventListener('click', function (e) {
        var targetId = href.slice(1);
        var targetEl = document.getElementById(targetId);
        if (!targetEl) return;
        e.preventDefault();
        var headerEl = document.querySelector('.header-wrapper');
        var offset = headerEl ? headerEl.offsetHeight + 14 : 76;
        var rect = targetEl.getBoundingClientRect();
        var top = window.pageYOffset + rect.top - offset;
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      });
    });
  }

    function initNextBatchDates() {
    var dateEls = document.querySelectorAll('[data-batch-date]');
    if (!dateEls.length) return;
    var months = ['JANUARY', 'FEBRUARY', 'MARCH', 'APRIL', 'MAY', 'JUNE', 'JULY', 'AUGUST', 'SEPTEMBER', 'OCTOBER', 'NOVEMBER', 'DECEMBER'];
    function ordinal(n) {
      var s = ['TH', 'ST', 'ND', 'RD'], v = n % 100;
      return n + (s[(v - 20) % 10] || s[v] || s[0]);
    }
    var now = new Date();
    dateEls.forEach(function (el) {
      var offset = parseInt(el.getAttribute('data-batch-date'), 10) || 0;
      var d = new Date(now.getTime());
      d.setDate(d.getDate() + offset);
      el.textContent = months[d.getMonth()] + ' ' + ordinal(d.getDate());
    });
  }

  function bootAll() {
    initNextBatchDates();
    initDtcJumpLinks();
    initBuyBoxAndSticky();
    initOneClickAddOns();
    initLiveDispatchEstimator();
    initSonicModesExplorer();
    initSmoothAnchorDrawerClose();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }
  document.addEventListener('shopify:section:load', bootAll);
})();
